// extracted by mini-css-extract-plugin
module.exports = {"collectionTOCContainer":"Collection_collectionTOCContainer__1syBv","emptyVersion":"Collection_emptyVersion__3oDda","unsupportedLink":"Collection_unsupportedLink__3khfC"};